import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { MailIcon } from 'lucide-react';
import { Language } from '../App';
interface NavbarProps {
  language: Language;
  setLanguage: (lang: Language) => void;
}
export function Navbar({
  language,
  setLanguage
}: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-espresso/80 backdrop-blur-lg shadow-lg' : 'bg-transparent'}`} data-id="element-132" data-mp="eje6cxibcvk9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-133" data-mp="1kzzrseesq6hu">
        <div className="flex items-center justify-between h-20" data-id="element-134" data-mp="1l1kooaol21iv">
          <div className="flex-1" data-id="element-135" data-mp="9nob6e9uki67">
            <h1 className="text-pearl text-xl sm:text-2xl font-bold tracking-wider" data-id="element-136" data-mp="9qtz3q6qpe0c">
              DERMALIPO
            </h1>
          </div>

          <div className="flex-1 flex justify-center" data-id="element-137" data-mp="jmdv0clb0cp3">
            <div className="flex items-center gap-2 bg-pearl/10 rounded-full px-4 py-2 border border-pearl/20" data-id="element-138" data-mp="jkszokr60pq6">
              <button onClick={() => setLanguage('en')} className={`px-3 py-1 rounded-full text-sm font-medium transition-all ${language === 'en' ? 'bg-pearl text-espresso' : 'text-pearl/60 hover:text-pearl'}`} data-id="element-139" data-mp="3n3dyt186a171">
                EN
              </button>
              <span className="text-pearl/40" data-id="element-140" data-mp="5mw33ocpojbi">|</span>
              <button onClick={() => setLanguage('es')} className={`px-3 py-1 rounded-full text-sm font-medium transition-all ${language === 'es' ? 'bg-pearl text-espresso' : 'text-pearl/60 hover:text-pearl'}`} data-id="element-141" data-mp="5offv4z5sc8j">
                ES
              </button>
            </div>
          </div>

          <div className="flex-1 flex justify-end" data-id="element-142" data-mp="318x5vlhy5tgh">
            <a href="mailto:contact@pearlannbrown.com" className="text-pearl hover:text-pearl/80 transition-colors" data-id="element-143" data-mp="2wbf209ise4fc">
              <MailIcon className="w-6 h-6" data-id="element-144" data-mp="3629qlkji9g3y" />
            </a>
          </div>
        </div>
      </div>
    </motion.nav>;
}